module.exports = __webpack_public_path__ + "static/media/main idea.241c3b03.mp3";